export const setSelectedCatalog = (catalog) => async (dispatch) => {
    await dispatch({
        type: 'SET_SELECTED_CATALOG',
        catalog,
    });
};
